import InputFieldWrapper from './InputFieldWrapper';

export { default as InputLabel } from './InputLabel';
export * from './InputPlaceholder';
export { default as ReduxFormFieldRenderInput } from './ReduxFormFieldRenderInput';
export { default as InputAddon } from './InputAddon';
export default InputFieldWrapper;
